import { cn } from '@/lib/utils'
import useGlobalStore from '@/store/useGlobalStore'
import Image from 'next/image'
import React from 'react'

interface Props extends React.HTMLAttributes<HTMLDivElement> {
  size?: number
}

export default function ProfilePicture({ size = 25, ...props }: Props) {
  const { user } = useGlobalStore()

  const getCorrectImage = () => {
    if (!user.isSignedIn) {
      return (
        <Image alt="User" height={size} width={size} src="/icons/account.svg" />
      )
    }

    const profilePicture = user.customer?.profilePicture

    if (profilePicture?.sizes[0]) {
      return (
        <Image
          style={{ height: size, width: size }}
          className="rounded-full object-cover"
          alt="User"
          height={size}
          width={size}
          src={profilePicture.sizes[0].media}
        />
      )
    }

    return (
      <div
        style={{ height: size, width: size }}
        className={cn(
          'flex items-center justify-center rounded-full bg-secondary font-bold text-white',
        )}
      >
        <span>{user.customer?.humanName.firstName[0]}</span>
        <span>{user.customer?.humanName.lastName[0]}</span>
      </div>
    )
  }

  return (
    <div
      style={{ height: size, width: size }}
      className="flex items-center justify-center"
      {...props}
    >
      {getCorrectImage()}
    </div>
  )
}
